import { NgClass } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import {
  IconDefinition,
  faFacebook,
  faInstagram,
  faLinkedin,
  faXTwitter,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import { BreakpointService } from 'src/app/services/breakpoint.service';
import { LocaleService } from 'src/app/services/locale.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [NgClass, RouterLink, MatIconModule, FaIconComponent],
})
export class FooterComponent {
  private readonly localeService: LocaleService = inject(LocaleService);
  readonly breakpointService: BreakpointService = inject(BreakpointService);
  readonly currentYear = new Date().getFullYear();
  readonly faFacebook: IconDefinition = faFacebook;
  readonly faInstagram: IconDefinition = faInstagram;
  readonly faLinkedin: IconDefinition = faLinkedin;
  readonly faXTwitter: IconDefinition = faXTwitter;
  readonly faYoutube: IconDefinition = faYoutube;
  readonly contactUsHref = `https://www.pcl.com/${this.localeService.regionCode.toLowerCase()}/en/contact-us`;
}
